import { inArray } from 'lib/component/validators';

export default {
  props: {
    variant: {
      type: String,
      validator: inArray([
        'primary',
        'secondary',
        'transparent',
        'outlined',
      ]),
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fluid: {
      type: Boolean,
      default: true,
    },
    actived: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedClasses() {
      return {
        [this.$style[this.variant]]: true,
        [this.$style.disabled]: this.disabled,
        [this.$style.actived]: this.actived,
      };
    },
    getStyles() {
      const buttonWidth = this.fluid ? '100%' : 'auto';
      return { width: buttonWidth };
    },
  },
};
